export enum UserRole {
  MANAGER = 'Manager',
  SECRETARY = 'Secretary',
  ADMIN = 'Admin'
}

export interface User {
  id?: string;
  email: string;
  name: string;
  role: UserRole;
  isActive?: boolean;
}

export interface UserProfile {
  id: string;
  name: string;
  email: string;
  role: string;
  avatar: string;
}

export interface AuthResponse {
  token: string;
  email: string;
  fullName: string;
  role: string;
}

export interface AuthResponseLocal {
  user: User;
  token: string;
  refreshToken?: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  password: string;
  confirmPassword: string;
}
